module.exports = __webpack_public_path__ + "img/ic_discord.bb5147ff.svg";